module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.isNotEmptyArray) ? _c('div', {
    staticClass: "wxc-rich-text weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, _vm._l((_vm.configList), function(v) {
    return _c('div', {
      staticClass: " weex-ct weex-div",
      attrs: {
        "weex-type": "div"
      }
    }, [(v.type == 'text' && v.value) ? _c('wxc-rich-text-text', {
      attrs: {
        "text-value": v.value,
        "text-style": v.style,
        "has-text-margin": _vm.hasTextMargin,
        "text-theme": v.theme
      }
    }) : _vm._e(), _vm._v(" "), (v.type == 'link' && v.href && v.value) ? _c('wxc-rich-text-link', {
      attrs: {
        "link-value": v.value,
        "link-href": v.href,
        "link-style": v.style,
        "has-text-margin": _vm.hasTextMargin,
        "link-theme": v.theme,
        "data-evt-wxcRichTextLinkClick": ""
      },
      on: {
        "wxcRichTextLinkClick": _vm.linkClick
      }
    }) : _vm._e(), _vm._v(" "), (v.type == 'icon' && v.src) ? _c('wxc-rich-text-icon', {
      attrs: {
        "icon-src": v.src,
        "icon-style": v.style
      }
    }) : _vm._e(), _vm._v(" "), (v.type == 'tag' && v.value) ? _c('wxc-rich-text-tag', {
      attrs: {
        "tag-value": v.value,
        "tag-theme": v.theme,
        "tag-style": v.style
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isString) ? _c('p', {
    staticClass: "default-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.configList))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34c3ccc6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34c3ccc6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-rich-text/index.vue
// module id = 217
// module chunks = 0 1